export const pipe =
  <T>(input: T) =>
  (handlers: ((input: T) => T)[]): T => {
    return handlers.reduce((curInput, handler) => handler(curInput), input)
  }
